import { render, staticRenderFns } from "./AudienceTitleWithParams.vue?vue&type=template&id=a6aaa880&scoped=true"
import script from "./AudienceTitleWithParams.vue?vue&type=script&lang=ts"
export * from "./AudienceTitleWithParams.vue?vue&type=script&lang=ts"
import style0 from "./AudienceTitleWithParams.vue?vue&type=style&index=0&id=a6aaa880&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aaa880",
  null
  
)

export default component.exports